/**
 * User-facing detail for a declined or failed BPOINT payment.
 *
 * BPOINT's APIResponse.ResponseText is often "Success" when the gateway call
 * itself succeeded, even if the bank declined the card (e.g. bank code 88).
 * Joining both texts produced "Declined — Success — Bank code 88".
 */

const SUCCESS_LIKE = /^(success|successful|ok|approved)$/i;

const cleanText = (value) => (typeof value === 'string' ? value.trim() : '');

const isSuccessLike = (text) => Boolean(text) && SUCCESS_LIKE.test(text);

export const formatPaymentRejectionDetail = (transactionResult = {}) => {
    const apiResponse = transactionResult.APIResponse || {};
    const txnResp = transactionResult.TxnResp || {};
    const apiText = cleanText(apiResponse.ResponseText);
    const bankText = cleanText(txnResp.ResponseText);
    const bankCode = txnResp.BankResponseCode == null ? '' : String(txnResp.BankResponseCode).trim();
    const bankDeclined = Boolean(bankCode) && bankCode !== '00';

    const outcomeText =
        (bankText && !isSuccessLike(bankText) && bankText) ||
        (apiText && !isSuccessLike(apiText) && apiText) ||
        (bankDeclined ? 'Declined' : '');

    const parts = [];
    if (outcomeText) parts.push(outcomeText);
    if (bankDeclined) parts.push(`Bank code ${bankCode}`);

    return [...new Set(parts)].join(' — ');
};
